import { useMemo } from 'react';
import { renderMarkdown } from '../../utils/markdownRenderer';

interface RichContentProps {
  content: string;
  className?: string;
}

/**
 * Renders markdown/rich text content with proper HTML formatting.
 * Supports: images, headings, bold, italic, lists, blockquotes, code blocks.
 * Content is sanitized to prevent XSS attacks.
 */
export default function RichContent({ content, className = '' }: RichContentProps) {
  const html = useMemo(() => renderMarkdown(content), [content]);

  return (
    <div
      className={`prose prose-sm dark:prose-invert max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
